<ng-container *ngIf="isDefectDetailsView; else defaultViewer">
  <div class="defect-image-viewer carousel">
    <div class="defect-image-viewer__meta">
      <div class="defect-image-viewer__meta-text">
        <div class="defect-image-viewer__author">{{ 'label.author' | loc }}: {{ data?.authorName || '-' }}</div>
        <div class="defect-image-viewer__name">{{ currentImage?.fileName || '' }}</div>
      </div>

      <button
        mat-stroked-button
        type="button"
        class="defect-image-viewer__download"
        [disabled]="downloading || !currentImage?.download || currentImage?.download?.location !== FileLocation.DEFECTS"
        (click)="download()"
      >
        <mat-icon>download</mat-icon>
        {{ 'button.save' | loc }}
      </button>
    </div>

    <div class="defect-image-viewer__image">
      <ng-content *ngTemplateOutlet="viewer"></ng-content>
    </div>

    <button mat-flat-button color="primary" type="button" class="defect-image-viewer__close" [mat-dialog-close]="false">
      {{ 'button.close' | loc }}
    </button>
    <button mat-flat-button *ngIf="!!currentImage.originalPath" color="secondary" type="button" (click)="toggleOriginal()">
      {{ 'defect.showPhoto' + (currentImage.showOriginal ? 'Edited' : 'Original') | loc }}
    </button>
  </div>
</ng-container>

<ng-template #defaultViewer>
  <div class="default-image-viewer">

    <div class="default-image-viewer__content">
      <ng-content *ngTemplateOutlet="viewer"></ng-content>
    </div>

    <div class="default-image-viewer__buttons">
      <app-icon-button icon="clear" [stroke]="true" [fliko]="true" color="primary" [mat-dialog-close]="false">
        {{ 'button.close' | loc }}</app-icon-button
      >
      <app-icon-button icon="download" [stroke]="true" [fliko]="true" [inverse]="true" color="primary" (click)="download()">{{
        'button.save' | loc
      }}</app-icon-button>
    </div>
  </div>
</ng-template>

<ng-template #viewer>
  <ng-container *ngIf="currentImageUrl as url">
    <div class="carousel-icon" (click)="back()">
      <mat-icon>arrow_back</mat-icon>
    </div>

    <img [src]="url" />

    <div class="carousel-icon" (click)="forward()">
      <mat-icon>arrow_forward</mat-icon>
    </div>
  </ng-container>
</ng-template>

